/**
 * @module compressed-json
 */
'use strict';

import compress from './compress';
import decompress from './decompress';
import bind from './bind';
/** @lends module:compressed-json */

var compressedJSON = {
  bind: bind,
  compress: compress,
  decompress: decompress
};
export { compress };
export { bind };
export { decompress };
export default compressedJSON;